import e from"react";import t from"prop-types";const p=({children:t})=>e.createElement("td",{className:"px-6 py-4 whitespace-nowrap text-sm font-medium"},t);p.propTypes={children:t.any};export{p as default};
